import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import setWrappedComponent from '../utils/react/setWrappedComponent';
import Spinner from '../components/Spinner';
import { isLogoutSelector } from '../selector/user';
import { isLoginSelector } from '../selector/user';

export default function withAuthGuard(WrappedComponent) {
  function AuthGuard(props) {
    const isPrivate = props?.route?.isPrivate;
    const isAnonymousOnly = props?.route?.isAnonymousOnly;
    const { isLogin, isLogout } = props;

    if ((!isPrivate && !isAnonymousOnly) || (isPrivate && isLogin) || (isAnonymousOnly && isLogout)) {
      return <WrappedComponent {...props} />;
    }

    if (isPrivate && isLogout) {
      return null;
    }

    if (isAnonymousOnly && isLogin) {
      return <Redirect to="/user/profile" />;
    }

    return (
      <div className="fixed inset-0 flex items-center justify-center">
        <Spinner className="flex-none" size="3.5rem" borderWidth="6px" />
      </div>
    );
  }

  setWrappedComponent(AuthGuard, WrappedComponent);

  const mapStateToProps = (state) => ({
    isLogin: isLoginSelector(state),
    isLogout: isLogoutSelector(state),
  })

  return connect(mapStateToProps)(AuthGuard);
}
